<template>
    <div class="vx-card p-6">
        <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full">
                <h3>Danh sách gói dịch vụ</h3>
            </div>
            <div class="vx-col sm:w-1/2 sm:mt-0 mt-2 w-full">
                <vs-button class="sm:float-right" color="primary" icon-pack="feather" icon="icon-plus"
                           @click="$router.push('/user/info-service-combo')" v-if="isPermissionCreateServiceCombo">
                    Thêm mới gói dịch vụ
                </vs-button>
            </div>
        </div>

        <div class="vx-row">
            <div class="vx-col lg:w-1/3 md:w-1/2 w-full mt-4">
                <label class="vs-input--label">Chi nhánh</label>
                <v-select class="w-full" v-model="selectedBranch" :options="branchOptions"
                          :clearable="false"></v-select>
            </div>
            <div class="vx-col lg:w-1/3 md:w-1/2 w-full md:mt-4 mt-2">
                <label class="vs-input--label">Dịch vụ</label>
                <v-select class="w-full" v-model="selectedServicePacks" :options="servicePacksOptions"
                          :clearable="false" :reduce="item => item.value"></v-select>
            </div>
            <div class="vx-col lg:w-1/3 md:w-1/2 w-full md:mt-4 mt-2">
                <label class="vs-input--label">Tìm kiếm</label>
                <vs-input class="w-full" v-model="keySearch" placeholder="Tìm kiếm theo tên hoặc mã"
                          v-on:keyup.enter="filter"></vs-input>
            </div>
            <div class="vx-col md:w-1/2 w-full lg:mt-4 md:mt-8 mt-2">
                <vs-button class="mt-2" iconPack="feather" icon="icon-search" color="primary"
                           @click="filter">Tìm
                    kiếm
                </vs-button>
            </div>
        </div>

        <ag-grid-vue style="height: 55vh" ref="agGridTable" :gridOptions="gridOptions"
                     class="ag-theme-material w-100 ag-grid-table" :columnDefs="columnDefs"
                     :defaultColDef="defaultColDef"
                     :rowData="comboServicePacks" :animateRows="true" :pagination="true"
                     :localeText="{ noRowsToShow: this.$t('menuCustomer.noRowsToShow') }"
                     :paginationPageSize="paginationPageSize"
                     :onGridReady="onGridReady" :suppressPaginationPanel="true">
        </ag-grid-vue>

        <div class="mt-4 flex flex-wrap" v-if="comboServicePacks.length > 0">
            <div class="">
                <div class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 flex flex-wrap">
                    <span class="my-auto mr-2">Số phần tử / trang:</span>
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                        <div
                            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium vx-col">
                                <span class="mr-2">
                                    {{
                                        comboServicePacks.length - currentPage * pageSize > 0 ? currentPage *
                                            pageSize
                                            : comboServicePacks.length
                                    }} /
                                    {{ totalElements }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                        </div>
                        <vs-dropdown-menu>
                            <vs-dropdown-item @click="changePageSize(20)">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="changePageSize(30)">
                                <span>30</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="changePageSize(50)">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="changePageSize(100)">
                                <span>100</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
            </div>
            <div class="ml-auto">
                <vs-pagination class="" :total="totalPages" v-model="currentPage" @change="loadPage"/>
            </div>
        </div>
    </div>
</template>

<script>

import {AgGridVue} from "ag-grid-vue";
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import vSelect from 'vue-select';
import Pagination from "../../../ui-elements/Pagination.vue";
import CellRendererActions from './cell-renderer/CellRendererActions.vue';
import {isAPI, isRouter} from "../../../../store/permission";
import {constAPI, constRouter} from "../../../../store/constant";

export default {
    components: {
        AgGridVue,
        vSelect,
        Pagination,
        CellRendererActions,
    },

    data() {
        return {
            gridApi: null,
            gridOptions: {},
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: this.$t('menuCustomer.stt'),
                    field: 'stt',
                    width: 100
                },
                {
                    headerName: 'Mã gói dịch vụ',
                    field: 'code',
                    width: 100
                },
                {
                    headerName: 'Tên gói dịch vụ',
                    field: 'name',
                    width: 200
                },
                {
                    headerName: 'Ghi chú',
                    field: 'description',
                    width: 150,
                },
                {
                    headerName: this.$t('button.actions'),
                    field: 'actions',
                    width: 150,
                    cellRendererFramework: 'CellRendererActions',
                },
            ],
            pageNumber: 0,
            pageSize: 50,
            totalPages: 0,
            currentPage: 1,
            totalElements: 0,
            branchOptions: [],
            selectedBranchValue: null,
            keySearch: null,
            comboServicePacks: [],
            servicePacksOptions: [],
            selectedServicePacks: 'null',
        }
    },

    watch: {
        '$store.state.windowWidth'(val) {
            if (val <= 1024) {
                this.maxPageNumbers = 5;
            } else {
                this.maxPageNumbers = 7;
            }

            if (val > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        '$store.state.reduceButton'() {
            setTimeout(() => {
                this.gridApi.sizeColumnsToFit();
            }, 650);
        },
        '$store.state.deleteComboService'(val) {
            if (val) {
                this.getAllComboService();
                this.$store.commit('DELETE_COMBO_SERVICE', false);
            }
        }
    },

    computed: {
        paginationPageSize() {
            if (this.gridApi) return this.gridApi.paginationGetPageSize();
            else return 20
        },

        selectedBranch: {
            get() {
                let obj = this.branchOptions.find(x => x.value === this.selectedBranchValue);
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedBranchValue = obj ? obj.value : null;
                this.getServicePacks();
            }
        },
    },

    async created() {

        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        this.branchOptions = branchList.map(x => {
            return {label: x.organizationBranchName, value: x.id}
        });
        this.branchOptions.unshift({value: null, label: 'Tất cả'});

        await this.getServicePacks();
        this.getAllComboService();
    },

    methods: {

        getServicePacks() {
            return new Promise((resolve, reject) => {
                this.$vs.loading()
                this.servicePacksOptions = [];
                this.$crm.post('/beauty-service-package-department/find-by-condition', {organizationBranchId: this.selectedBranchValue}).then(res => {
                    let result = res.data.content.map(x => x.beautyServicePackage);
                    result.map(el => {
                        let check = this.servicePacksOptions.find(x => x.id == el.id) ? true : false;
                        if (!check) {
                            this.servicePacksOptions.push(el);
                        }
                    })
                    this.servicePacksOptions = this.servicePacksOptions.map(q => {
                        return {
                            label: q.code + '-' + q.name,
                            value: q.id
                        }
                    });
                    this.servicePacksOptions.unshift({value: 'null', label: 'Tất cả'});
                    resolve();
                    this.$vs.loading.close();
                }).catch((err) => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        getAllComboService() {
            let payload = {
                keySearch: this.keySearch,
                organizationBranchId: this.selectedBranchValue,
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
                beautyServicePackageId: JSON.parse(this.selectedServicePacks)
            }

            this.$vs.loading();
            this.$crm.post('/beauty-package-combo/find-by-condition', payload).then(res => {
                this.comboServicePacks = res.data.content.map(el => {
                    el.stt = this.pageNumber * this.pageSize + res.data.content.indexOf(el) + 1;
                    return el;
                })
                this.totalPages = res.data.totalPages;
                this.totalElements = res.data.totalElements;
                this.$vs.loading.close();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },

        onGridReady() {
            if (this.$store.state.windowWidth <= 1024) {
                this.maxPageNumbers = 5;
            } else {
                this.maxPageNumbers = 7;
            }

            if (this.$store.state.windowWidth > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },

        loadPage: function (currentPage) {
            if (this.pageNumber !== parseInt(currentPage) - 1) {
                this.pageNumber = parseInt(currentPage) ? parseInt(currentPage) - 1 : 0;
                this.getAllComboService();
            }
        },

        changePageSize(number) {
            this.pageSize = number;
            this.pageNumber = 0;
            this.currentPage = 1;
            this.getAllComboService();
        },

        filter() {
            this.currentPage = 1;
            this.pageNumber = 0;
            this.getAllComboService();
        },

        isPermissionCreateServiceCombo() {
            return isAPI(this, constAPI.beauty_pack_create);
        },
    },

    mounted() {
        this.gridApi = this.gridOptions.api;
    },
}
</script>
